import { SvgIconProps } from '@mui/material';

import { PdfIcon } from 'assets/icons/fileTypes/PdfIcon';
import { DocIcon } from 'assets/icons/fileTypes/DocIcon';
import { DocxIcon } from 'assets/icons/fileTypes/DocxIcon';
import { ImageIcon } from 'assets/icons/fileTypes/ImageIcon';
import { XlsIcon } from 'assets/icons/fileTypes/XlsIcon';
import { XlsxIcon } from 'assets/icons/fileTypes/XlsxIcon';
import { MusicIcon } from 'assets/icons/fileTypes/MusicIcon';
import { CsvIcon } from 'assets/icons/fileTypes/CsvIcon';
import { PptIcon } from 'assets/icons/fileTypes/PptIcon';
import { PptxIcon } from 'assets/icons/fileTypes/PptxIcon';
import { TxtIcon } from 'assets/icons/fileTypes/TxtIcon';
import { ZipIcon } from 'assets/icons/fileTypes/ZipIcon';
import { JsonIcon } from 'assets/icons/fileTypes/JsonIcon';
import { GenericIcon } from 'assets/icons/fileTypes/GenericIcon';

const fileIconMap: Record<string, React.FC<SvgIconProps>> = {
  pdf: PdfIcon,
  doc: DocIcon,
  docx: DocxIcon,
  xls: XlsIcon,
  xlsx: XlsxIcon,
  png: ImageIcon,
  jpg: ImageIcon,
  jpeg: ImageIcon,
  gif: ImageIcon,
  mp3: MusicIcon,
  wav: MusicIcon,
  mp4: MusicIcon,
  mov: MusicIcon,
  csv: CsvIcon,
  ppt: PptIcon,
  pptx: PptxIcon,
  txt: TxtIcon,
  zip: ZipIcon,
  rar: ZipIcon,
  json: JsonIcon,
};

export const getFileIcon = (extension: string): React.FC<SvgIconProps> =>
  fileIconMap[extension.toLowerCase()] || GenericIcon;
